import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Modal from 'components/Modal';
import classnames from 'classnames';
import numeral from 'numeral';

const OPTIMIZED = 'OPTIMIZED';
const ORIGINAL = 'ORIGINAL';

const ImagePreviewModal = createReactClass({
  propTypes: {
    isOpen: PropTypes.bool.isRequired,
    workingSetImage: ImmutablePropTypes.record.isRequired,
    onClosed: PropTypes.func.isRequired,
  },

  getInitialState() {
    return {
      type: OPTIMIZED,
    };
  },

  handleShowOptimized(event) {
    event.preventDefault();

    this.setState({type: OPTIMIZED});
  },

  handleShowOriginal(event) {
    event.preventDefault();

    this.setState({type: ORIGINAL});
  },

  handleClosed(event) {
    if (event) event.preventDefault();

    this.props.onClosed();
  },

  render() {
    const {workingSetImage} = this.props;
    const {type} = this.state;
    const showOriginal = (type === ORIGINAL);
    const showOptimized = (type === OPTIMIZED);
    const imgSrc = (showOptimized) ? workingSetImage.optimizedUrl : workingSetImage.originalUrl;

    return (
      <Modal contentLabel="Image preview" isOpen={this.props.isOpen} onRequestClose={this.handleClosed} className="modal-fw">
        <div className="modal-content asset-preview-large-modal">
          <button onClick={this.handleClosed} type="button" className="close close-dangle">
            <span aria-hidden="true"><i className="ficon ficon-times"></i></span>
          </button>

          <div className="modal-body">
            <ul className="nav nav-tabs-inline m-xs-b-md">
              <li onClick={this.handleShowOptimized} className={classnames('nav-item', {active: showOptimized})}><a className="nav-link" href="#">Optimized ({numeral(workingSetImage.optimizedSize).format('0.0 b')})</a></li>
              <li onClick={this.handleShowOriginal} className={classnames('nav-item', {active: showOriginal})}><a className="nav-link" href="#">Original ({numeral(workingSetImage.originalSize).format('0.0 b')})</a></li>
            </ul>

            <div className="bg-img-checkered p-xs-ymd text-xs-center">
              <img className="asset-uploaded-preview-source" src={imgSrc} alt={workingSetImage.name} />
            </div>
          </div>
        </div>
      </Modal>
    );
  },
});

export default ImagePreviewModal;



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/ImagePreviewModal.js